import { FeatureFlagResults, FeatureFlagResult } from '@moda/portal-stanchions';
import { mapObjIndexed } from 'ramda';

export const formatFeatureFlags = (flags: FeatureFlagResults) => {
  return mapObjIndexed((flag: FeatureFlagResult) => flag.value, flags);
};
